// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8e2a680","879":"edd7a514"}[chunkId] + ".chunk.js";
};